import { TranscriptSchema } from "../../schemas/transcript";
/**
 * Parse transcript from JSON string.
 * @throws zod error if invalid
 */
export function parseJsonTranscript(content) {
    const parsed = JSON.parse(content);
    return TranscriptSchema.parse(parsed);
}
